export default "__VITE_ASSET__6aRltIki__"